export const getDataInNode = <T extends {}>(data: FormatLabel<T>) =>
  'node' in data ? data.node : data
